import HoldingReportUseCase from "@domains/useCases/Reports/holdings/HoldingReport";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import HoldingCommonUseCase, { DashboardHoldingSummarizedUseCase, FilterUseCase, SearchUseCase, SortUseCase, SummarizedUseCase, } from "@domains/useCases/Reports/holdings/hodlingsCommonUsecase";
import StreamUseCase from "@domains/useCases/StreamUsecase";
import DPTransactionReportUseCase from "@domains/useCases/Reports/holdings/DPTransactionReport";
import DPTransactionSubmitUseCase from "@domains/useCases/Reports/holdings/DPTransactionSubmitUseCase";
import DPIdsReportUseCase from "@domains/useCases/Reports/holdings/DPIdsUseCase";
import DashboardHoldingSummaryUseCase from "@domains/useCases/Reports/dashboard/DashboardHoldingUseCase";
import dpPullUseCase from "@domains/useCases/Reports/holdings/DpPullUseCase";
export default (repositories) => {
    return {
        holdingReport: new HoldingReportUseCase(repositories.holdingMainScreenRepo),
        commonHoldings: new HoldingCommonUseCase(new SearchUseCase(), new FilterUseCase(), new SortUseCase(), new SummarizedUseCase(), new DashboardHoldingSummarizedUseCase()),
        downloadPDFReports: new DownloadPDFReport(repositories.downloadRepo),
        downloadExcelReports: new DownloadExcelReport(repositories.downloadRepo),
        sendEmailReports: new EmailReport(repositories.downloadRepo),
        quoteStream: new StreamUseCase(repositories.quoteStream),
        dpTransactionUseCase: new DPTransactionReportUseCase(repositories.dpTransactionRepo),
        dpTransactionSubmitUseCase: new DPTransactionSubmitUseCase(repositories.dpTransactionRepo),
        dpIds: new DPIdsReportUseCase(repositories.dpTransactionRepo),
        dashboardHoldingSummaryUseCase: new DashboardHoldingSummaryUseCase(repositories.dashboardRepo),
        dpPullUseCase: new dpPullUseCase(repositories.dpTransactionRepo),
    };
};
